/* eslint-disable react-hooks/exhaustive-deps */
import "./Sass/App.scss";
import { useReducer, useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Axios from "axios";

// States And Dispatch
import StateContext from "./StateContext";
import DispatchContext from "./DispatchContext";
// Material Ui
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
// Pages
import Dashboards from "./Pages/Dashboard";
import Dashboardv2 from "./Pages/Dashboardv2/Dashboardv2";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Wallet from "./Pages/Wallet";
import Invoice from "./Pages/Invoice";
import InvoiceDesktop from "./Components/InvoiceDesktop";
// import History from './Pages/History'
import Payment from "./Pages/Payment";
import OldPayment from "./Pages/OldPayment";
import RestaurantInvoicePaymentOneScreen from "./Pages/RestaurantInvoicePaymentOneScreen";
import WalletMob from "./Components/WalletMob";
import SetPassword from "./Pages/SetPassword";

// import Localization pakeges
import { withTranslation, Trans } from "react-i18next";
//  import Cookies Functions
import { setCookie, getCookie, erase, parseCookieJson } from "./Functions/cookieFunction";
import SignupPhoneModal from "./Components/signupPhoneModal/signupPhoneModal";
import VerifyPhoneNumber from "./Components/verifyPhoneNumber/verifyPhoneNumber";
import LoaderAnimation from "./Components/LoaderAnimation";
import SignupModal from "./Components/signupModal/signupModal";
import Alert from "./Components/Alert";
import Backdrop from "@mui/material/Backdrop";
import AuthScreen from "./Pages/AuthScreen";
import { handleError } from "./Functions/getAlert";
import Error404 from "./Pages/Error404/error404";
import OrderStatus from "./Pages/orderStatus/OrderStatus";
import { updateManifest } from "./Functions/updateManifest"
import { getClosePayments } from "./Functions/getClosePayments";
import { handlepaymentMethods } from "./Functions/handlepaymentMethods";
import vendorsConfig from "./vendorsConfig";





// Styles -- Material Ui
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));

function App({ t, i18n }) {
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();



  // Initial State
  const initialState = {
    authToken: getCookie("tokenAuth") ? getCookie("tokenAuth") : "",
    langValue: parseCookieJson(localStorage.getItem("Language")) || "en",
    loggedIn: Boolean(getCookie("tokenAuth")),
    login: "",
    cardList: [],
    allDetails: "",
    token: getCookie("tokenAuth"),
    loading: true,
    directoryURL: "/",
    cityList: [],
    alertMessage: { open: false, Message: "" },
    profile: parseCookieJson(localStorage.getItem("Profile")) || [],
    wallet: {},
    saveCardModal: false,
    payCard: "",
    loginModal: false,
    otpModal: false,
    signUpPhoneModal: false,
    signUpModal: false,
    fieldValues: [],
    freezScreen: false,
    alert: {
      show: false,
      message: "",
      type: "",
    },
    splitBillOptions: false,
    payForItems: false,
    divideBill: false,
    payCustomAmount: false,
    shareInvoiceQrcode: false,
    splitBill: false,
    reviewModal: true,
    storeInfo: null,
    allowNotificationPopupMode: false,
    closePayments:null,
    acceptedPayments:[],
    deliveryRiderInfo:[]




  };
  // Action Or State Data Update
  function ourReducer(state, action) {
    switch (action.type) {
      case "setAuthToken":
        return { ...state, authToken: action.authToken };
      case "LangChange":
        return { ...state, langValue: action.langValue };
      case "login":
        return {
          ...state,
          login: action.login,
          token: action.token,
          loggedIn: true,
        };
      case "logout":
        return { ...state, login: "", token: null, loggedIn: false };
      case "DetailsAdd":
        return {
          ...state,
          allDetails: action.allDetails,
          loading: action.loading,
        };
      case "Add_Areas_Cities":
        return { ...state, cityList: action.cityList };
      case "UpdateProfile":
        return { ...state, profile: action.profile };
      case "WalletInf":
        return { ...state, wallet: action.wallet };
      // case "setSaveCardsModal":
      //   return { ...state, saveCardModal: action.saveCardModal };
      case "updatedCardList":
        return {
          ...state,
          cardList: action.cardList,
        };
      case "payCard":
        return {
          ...state,
          payCard: action.payCard,
        };
      case "setLoginModal":
        return {
          ...state,
          loginModal: action.loginModal,
        };
      case "setSignUpPhoneModal":
        return {
          ...state,
          signUpPhoneModal: action.signUpPhoneModal,
        };
      case "setOtpModal":
        return {
          ...state,
          otpModal: action.otpModal,
        };
      case "setSplitBillOptions":
        return {
          ...state,
          splitBillOptions: action.splitBillOptions,
        };
      case "setReviewModal":
        return {
          ...state,
          reviewModal: action.reviewModal,
        };
      case "setPayForItems":
        return {
          ...state,
          payForItems: action.payForItems,
        };
      case "setDivideBill":
        return {
          ...state,
          divideBill: action.divideBill,
        };
      case "setPayCustomAmount":
        return {
          ...state,
          payCustomAmount: action.payCustomAmount,
        };
      case "setShareInvoiceQrcode":
        return {
          ...state,
          shareInvoiceQrcode: action.shareInvoiceQrcode,
        };
      case "setDeliveryRiderInfo":
        return {
          ...state,
          deliveryRiderInfo: action.deliveryRiderInfo,
        };
      case "setSplitBill":
        return {
          ...state,
          splitBill: action.splitBill,
        };
      case "setSignUpModal":
        return {
          ...state,
          signUpModal: action.signUpModal,
        };
      case "setFieldValues":
        return {
          ...state,
          fieldValues: action.fieldValues,
        };
      case "Set_FreezScreen":
        return {
          ...state,
          freezScreen: action.freezScreen,
        };
      case "SHOW_ALERT":
        return {
          ...state,
          alert: {
            show: true,
            message: action.message,
            type: action.alertType,
          },
        };
      case "SET_STORE_INFORMATION":
        return { ...state, storeInfo: action.storeInfo };
      case "setAllowNotificationPopupMode":
        return { ...state, allowNotificationPopupMode: action.allowNotificationPopupMode };
        case "setClosePayments":
          return{
            ...state,
            closePayments: action.closePayments ?? state.closePayments
          }
          case "Set_Accepted_Payments":
            return{
              ...state,
              acceptedPayments: action.acceptedPayments 
            }
      case "HIDE_ALERT":
        return {
          ...state,
          alert: {
            show: false,
            message: "",
            type: "",
          },
        };
      default:
    }
  }

  // Using Reducer
  const [state, dispatch] = useReducer(ourReducer, initialState);


  const getSaveCards = async () => {
    var credToken = getCookie("tokenAuth");
    if (credToken !== "" && credToken !== null) {
      try {
        const newReq = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/get_card`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );
        // console.log(newReq.data.data, "get Save cart");

        dispatch({ type: "updatedCardList", cardList: newReq.data.data });
      } catch (e) {
        Promise.reject(e);
        // handleError(e, dispatch)
        erase("tokenAuth");
        erase("Profile");
        dispatch({ type: "logout" });

      }
    }
  };

  const handleLogout = () => {
    dispatch({ type: "logout" });
  };

  const getWallet = async () => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}customer`,
        {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch({ type: "UpdateProfile", profile: response.data.data });
        setCookie("Profile", JSON.stringify(response.data.data));
      }
    } catch (e) {
      if (e.response != undefined) {
        handleLogout();
      }
      else
        if (e.response.status == 401) {
          handleLogout();
        }
      handleError(e, dispatch)
      Promise.reject(e);
    }
  };




  useEffect(() => {

    if (state?.token) {
      // getWallet();
      getSaveCards();
    }
  }, [state?.token]);

  // Adding or Removing User ID From sessionStorage
  useEffect(() => {
    if (state?.loggedIn) {
      // sessionStorage.setItem("token", state.token)
      // sessionStorage.setItem('userId', state.login)
      state.alertMessage.open = false;
      state.alertMessage.Message = "Logged In Successfully";
    } else {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userId");
      erase("tokenAuth");
      erase("Profile");
      // goToAuth()
    }
  }, [state?.loggedIn]);

  // language handle component
  const onLanguageHandle = () => {
    i18n.changeLanguage(state.langValue);
    localStorage.setItem("Language", JSON.stringify(state.langValue));
  };

  useEffect(() => {
    onLanguageHandle();
  }, [state.langValue]);

  

  const goBackMain = () => {
    dispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: false,
    });

  };

  useEffect(() => {
    if (getCookie("Profile") && getCookie("tokenAuth")) {
      const profile = parseCookieJson(getCookie("Profile"));
      if (profile) {
        dispatch({ type: "UpdateProfile", profile });
        dispatch({ type: "setAuthToken", authToken: getCookie("tokenAuth") });
        dispatch({ type: "login", token: getCookie("tokenAuth"), loggedIn: true });
      } else {
        // Corrupt / unexpected cookie format — clear so invoice pages can load
        erase("Profile");
        erase("tokenAuth");
      }
    }
    // console.log(getCookie("Profile"),'getCookie("Profile")', getCookie("tokenAuth"));
  }, [])

  useEffect(() => {
      
  if ((state.shareInvoiceQrcode || state.allowNotificationPopupMode)) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "visible";
  }
  }, [state.shareInvoiceQrcode , state.allowNotificationPopupMode])



  useEffect(() => {
    if (state.storeInfo != null) {
      updateManifest(state);
    }
  }, [state.storeInfo]);


  useEffect(()  => {
    if(state?.storeInfo){
      getClosePayments(state,dispatch)
    }
  }, [state?.storeInfo])

  useEffect(() => {
    if(state?.closePayments &&  state?.storeInfo){
    handlepaymentMethods(state,dispatch)
    }else{
      dispatch({
        type: "Set_Accepted_Payments",
        acceptedPayments: state?.storeInfo?.payments,
      });
    }
  }, [state?.storeInfo,state?.closePayments])

  // useEffect(() => {
  //   if(state?.acceptedPayments.length>0){
  //     let storeData  = {...state?.storeInfo,payments:state?.acceptedPayments}
  //     console.log("storeData", storeData)
  //     // dispatch({
  //     //   type: "SET_STORE_INFORMATION",
  //     //   storeInfo: storeData,
  //     // });
  //   }
  // }, [state?.acceptedPayments])
  useEffect(() => {
    document.title = vendorsConfig.NAME;
  if(vendorsConfig.PRIMARY){
    document.documentElement.style.setProperty('--primary', vendorsConfig.PRIMARY, 'important');
  }
  if(vendorsConfig.SECONDARY){
    document.documentElement.style.setProperty('--secondary', vendorsConfig.SECONDARY, 'important');
    document.documentElement.style.setProperty("--th-primary",vendorsConfig.SECONDARY, 'important');
  }
  if(vendorsConfig.APP_FAVICON && vendorsConfig.APP_FAVICON !== null){
    const favIcon = document.querySelector('link[rel="icon"]');
    if(favIcon){
      favIcon.href = vendorsConfig.APP_FAVICON;
    } else {
      // Create favicon link if it doesn't exist
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = vendorsConfig.APP_FAVICON;
      document.head.appendChild(link);
    }
  }
}, [vendorsConfig])
  // if(isLoading) return <div className={classes.root}><CircularProgress /></div>
  if (isLoading)
    return (
      <div className={classes.root}>
        <LoaderAnimation type="l3" />
      </div>
    );





  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        <div
          style={
            state.langValue === "ar"
              ? { direction: "rtl" }
              : { direction: "ltr" }
          }
        >

          {state.alert.show ? (
            <Alert
              type={state.alert.type}
              show={state.alert.show}
              message={state.alert.message}
            />
          ) : (
            ""
          )}
          {state.freezScreen && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={state.freezScreen}
            >
              <LoaderAnimation />
            </Backdrop>
          )}
            {(state.shareInvoiceQrcode || state.allowNotificationPopupMode) && (
            <Backdrop
            onClick={goBackMain}
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 3,
              }}
              open={
                state.shareInvoiceQrcode || state.allowNotificationPopupMode
              }
            />
          )}
          <BrowserRouter>
            <Switch>
              <Route exact path={`/`}>
                <AuthScreen />
              </Route>
              <Route exact path={`/test1`}>
                <SignupModal />
              </Route>
              <Route exact path={`/customer/:resetId`}>
                <SetPassword />
              </Route>
              <Route exact path={`/register`}>
                <Register />
              </Route>
              <Route exact path={`/invoice/:invoiceType/:id`}>
                <Payment />
              </Route>
              <Route exact path={`/delivery/:id`}>
                <Payment />
              </Route>
              <Route exact path={`/pickup/:id`}>
                <Payment />
              </Route>
              <Route exact path={`/restaurant-invoice-demo`}>
                <RestaurantInvoicePaymentOneScreen />
              </Route>
              <Route exact path={`/invoiceold/:type/:id`}>
                <OldPayment />
              </Route>
              <Route exact path={`/invoice/paid/:id`}>
                <Invoice />
              </Route>{" "}
              <Route exact path={`/loaderanimation`}>
                <LoaderAnimation />
              </Route>{" "}

              <Route path={`/orderstatus`}>
                <OrderStatus />
              </Route>
              {state.loggedIn ? (
                <>
                  <Route path={`/dashboard`}>
                    <Dashboardv2 />
                    {/* <Dashboards /> */}
                  </Route>

                  <Route path={`/orderstatus`}>
                    <OrderStatus />
                  </Route>
                </>

                //  <Route exact path={`/wallet`}>
                //     <Wallet />
                //   </Route> 
                //    <Route exact path={`/walletmob`}>
                //     <WalletMob />
                //   </Route>{" "} 

              ) : (
                <Redirect to="/" />
              )}
              <Route path="*">
                <Error404 />
              </Route>
            </Switch>
          </BrowserRouter>
        </div>
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
}

export default withTranslation()(App);
